import React from 'react';

import './styles.scss';
import * as fonts from '../../../../util/fonts';
import {createClassName} from '../../../../util/utility';
import Icon from '../../../icon';
import {Icons} from '../../../../util/icons';
import {Column} from '../../../layout';

interface StepImageProps {
  step?: any;
  stepFill?: string;
  color?: string;
}

function StepImage({step, stepFill, color}: StepImageProps) {
  const classes = createClassName('step-image-container', '');

  return (
    <div className="step-image-div">
      <Column className="step-image-column">
        <Icon
          className={classes}
          name={Icons.STEPPER_STEP}
          width="63"
          height="59"
          fill={stepFill}
          color={color}
        />
        <div
          className="step-image-number"
          style={{...fonts.L, textDecoration: 'bold'}}>
          {step}
        </div>
      </Column>
    </div>
  );
}

export default StepImage;
